import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaSlider from "../../../../../../components/common/BriaSlider/BriaSlider";
import { IMAGE_REFERENCE_CONFIGS } from "../../../../../../constants/TextToImageConstants";
import { useAppStore } from "../../../../../../hooks/useStores";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";

const TextToImageSteps = () => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.config" });
	const { textToImageStore } = useAppStore();

	const handleStepsChange = (_event: any, steps: number | number[]) => {
		textToImageStore.handleConfigChange("steps_num", steps as number);
	};

	const getMinSteps = () => {
		if (textToImageStore.config.tailored_model_id) {
			if (textToImageStore.config.training_version === "max") {
				return IMAGE_REFERENCE_CONFIGS.steps.not_fast.min;
			} else {
				const isFast = textToImageStore.config.fast;
				return isFast ? IMAGE_REFERENCE_CONFIGS.steps.fast.min : IMAGE_REFERENCE_CONFIGS.steps.not_fast.min;
			}
		} else {
			return textToImageStore.models[textToImageStore.config.model]?.steps?.min;
		}
	};

	const getMaxSteps = () => {
		if (textToImageStore.config.tailored_model_id) {
			if (textToImageStore.config.training_version === "max") {
				return IMAGE_REFERENCE_CONFIGS.steps.not_fast.max;
			} else {
				const isFast = textToImageStore.config.fast;
				return isFast ? IMAGE_REFERENCE_CONFIGS.steps.fast.max : IMAGE_REFERENCE_CONFIGS.steps.not_fast.max;
			}
		} else {
			return textToImageStore.models[textToImageStore.config.model]?.steps.max;
		}
	};

	return (
		<InputLayout label={t("steps.label")} info={t("steps.info")}>
			<BriaSlider
				value={textToImageStore.config.steps_num}
				onChange={handleStepsChange}
				step={1}
				min={getMinSteps()}
				max={getMaxSteps()}
				valueLabelDisplay="on"
			/>
		</InputLayout>
	);
};

export default observer(TextToImageSteps);
